import { render } from "./ResourceManagement.vue?vue&type=template&id=456642ff&ts=true"
import script from "./ResourceManagement.vue?vue&type=script&lang=ts"
export * from "./ResourceManagement.vue?vue&type=script&lang=ts"

import "./ResourceManagement.vue?vue&type=style&index=0&id=456642ff&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__